import { FC } from "react";
import { IconPropsType } from ".";

export const ExcelBadge: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 24}
      height={props.size ?? 24}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16.0002C2 10.3769 6.55856 5.81836 12.1818 5.81836H19.8182C25.4414 5.81836 30 10.3769 30 16.0002C30 21.6234 25.4414 26.182 19.8182 26.182H12.1818C6.55856 26.182 2 21.6234 2 16.0002Z"
        fill="#E6FBE4"
      />
      <path
        d="M13.8325 15.9886H11.5455V17.4272H14.249V18.5456H10.0915V12.5137H14.2567V13.636H11.5455V14.9087H13.8325V15.9886Z"
        fill="#45BA4A"
      />
      <path
        d="M16.5942 15.2982L17.2421 14.0641H18.6922L17.5121 16.247L18.7501 18.5456H17.2922L16.5864 17.2189L15.8961 18.5456H14.4305L15.6724 16.247L14.4961 14.0641H15.9616L16.5942 15.2982Z"
        fill="#45BA4A"
      />
      <path
        d="M21.3118 18.6266C20.6228 18.6266 20.0661 18.4222 19.6419 18.0134C19.2176 17.602 19.0055 17.0685 19.0055 16.4128V16.2971C19.0055 15.8369 19.0903 15.4319 19.26 15.0823C19.4297 14.7326 19.6766 14.4613 20.0005 14.2685C20.3271 14.0757 20.714 13.9792 21.1614 13.9792C21.7914 13.9792 22.2889 14.1746 22.654 14.5655C23.0191 14.9563 23.2016 15.5014 23.2016 16.2007V16.7445H20.4248C20.4736 16.9939 20.5816 17.1906 20.7487 17.3346C20.9184 17.4786 21.1383 17.5506 21.4082 17.5506C21.8479 17.5506 22.1925 17.3963 22.4419 17.0878L23.0821 17.8398C22.9072 18.0815 22.6604 18.2731 22.3416 18.4145C22.0228 18.5559 21.6795 18.6266 21.3118 18.6266ZM21.1537 15.0591C20.7449 15.0591 20.5019 15.3291 20.4248 15.869H21.8325V15.7341C21.8325 15.5232 21.7746 15.3587 21.6589 15.2404C21.5432 15.1196 21.3748 15.0591 21.1537 15.0591Z"
        fill="#45BA4A"
      />
    </svg>
  );
};
